import { useSessionStore as e } from "../stores/session-store/useSessionStore.js";
import { useCallback as t } from "react";
import { useLocation as n } from "/home/runner/work/oko-web/oko-web/node_modules/react-router/dist/development/index.mjs";
//#region src/lib/hooks/usePing.ts
var r = () => {
	let r = n(), i = e((e) => e.setIsServiceOnline);
	return t((e) => {
		e.users.ping().then((e) => {
			i((t) => (t === !1 && e === !0 && r.pathname.match(/\/space\/([0-9a-fA-F]+)$/gm), e));
		});
	}, []);
};
//#endregion
export { r as usePing };
